import * as yup from 'yup';
import { SiteCategory, SiteType } from '../../../apiRtk/be4feApi';

export function getChangeSiteTypeModalValidationSchema() {
  return yup.object().shape({
    siteCategory: yup.mixed<SiteCategory>().required(),
    siteType: yup.mixed<SiteType>().required(),
  });
}
